import { cn } from '@library/component-utils/cn';

export interface CellProps {
  cellClassName?: string;
  children: React.ReactNode;
}

export const Cell = ({ cellClassName = '', children }: CellProps) => {
  return (
    <div
      className={cn(
        'text-soClean-100 flex h-full items-center px-3',
        cellClassName
      )}
    >
      {children}
    </div>
  );
};
